module.exports = __webpack_public_path__ + "static/media/sign-in_mobile.681701c9.png";